G.BoardBackground = function(boardObj) {
		
	Phaser.Group.call(this,game);

	this.board = boardObj;
	this.borderSize = G.l(8);

	this.renderTexture = game.add.renderTexture(1, 1);

	this.markerImg = game.make.image();
  this.markerImg.anchor.setTo(0.5);

	//this.redraw();

  this.onDestroy.add(function() {
    this.renderTexture.destroy(true);
  }, this);

};

G.BoardBackground.prototype = Object.create(Phaser.Group.prototype);

G.BoardBackground.prototype.redraw = function() {
	this.renderTexture.resize(
		(this.board.boardData.width+2)*this.board.tilesize,
		(this.board.boardData.height+2)*this.board.tilesize,
		true
	);
	this.renderTexture.clear();
	this.drawBg();


};



G.BoardBackground.prototype.drawBg = function() {

  var ts = this.board.tilesize;

  for (var col = -1; col < this.board.boardData.width+1; col++) {
    for (var row = -1; row < this.board.boardData.height+1; row++) {

      var tile = this.checkIfTile(col, row);
      var up = this.checkIfTile(col,row-1);
      var down = this.checkIfTile(col,row+1);
      var left = this.checkIfTile(col-1,row);
      var right = this.checkIfTile(col+1,row);
      var ur = this.checkIfTile(col+1,row-1);
      var ul = this.checkIfTile(col-1,row-1);
      var dr = this.checkIfTile(col+1,row+1);
      var dl = this.checkIfTile(col-1,row+1);

      if (tile) {
        this.drawSprite(col, row, 'tile_'+(1+((col%2 + row%2)%2)), 0);
        continue;
      }

      if (up) this.drawSprite(col,row,'tile_border_straight',180);
      if (down) this.drawSprite(col,row,'tile_border_straight',0);
      if (left) this.drawSprite(col,row,'tile_border_straight',90);
      if (right) this.drawSprite(col,row,'tile_border_straight',270);

      if (dr && !right && !down) this.drawSprite(col,row,'tile_border_outside_corner',0);
      if (dl && !left && !down) this.drawSprite(col,row,'tile_border_outside_corner',90);
      if (ur && !right && !up) this.drawSprite(col,row,'tile_border_outside_corner',270);
      if (ul && !left && !up) this.drawSprite(col,row,'tile_border_outside_corner',180);

      if (down && right) this.drawSprite(col,row,'tile_border_inside_corner',0);
      if (down && left) this.drawSprite(col,row,'tile_border_inside_corner',90);
      if (up && right) this.drawSprite(col,row,'tile_border_inside_corner',270);
      if (up && left) this.drawSprite(col,row,'tile_border_inside_corner',180);

    }
  }

};


G.BoardBackground.prototype.drawSprite = function(x, y, sprite, angle) {

  var px = {
    x: x * this.board.tilesize,
    y: y * this.board.tilesize,
  }

  this.markerImg.angle = angle || 0;
  G.changeTexture(this.markerImg, sprite);
  this.markerImg.updateTransform();

  this.renderTexture.renderXY(this.markerImg, px.x+(this.board.tilesize*1.5), px.y+(this.board.tilesize*1.5))

};

G.BoardBackground.prototype.checkIfTile = function(x,y) {

  var val = this.board.boardData.get(x, y);

  if (val === false) {
    return false;
  } else {
    if (val === 'X') {
      return false;
    } else {
      return true;
    }
  }

};